import { useState } from "react";
import { menuItems, menuCategories } from "@/mocks/menuItems";

export default function MenuSection() {
  const [activeCategory, setActiveCategory] = useState("Tümü");

  const filtered = activeCategory === "Tümü"
    ? menuItems
    : menuItems.filter((item) => item.category === activeCategory);

  return (
    <section id="menu" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-[#e8734a] text-sm font-semibold mb-4">
            <i className="ri-restaurant-line"></i>
            Menümüz
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a3a4a] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Günün Taze Lezzetleri
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Her gün taze avlanan balıklar ve geleneksel Ege tariflerimizle hazırlanan özel menümüz
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {menuCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? "bg-[#1a3a4a] text-white"
                  : "bg-[#f5f3f0] text-[#1a3a4a] hover:bg-[#e8734a]/10"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Menu Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((item) => (
            <div
              key={item.id}
              className="bg-white border border-gray-100 rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300 group"
            >
              {/* Image */}
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {item.tag && (
                  <span className="absolute top-3 left-3 bg-[#e8734a] text-white text-xs font-semibold px-3 py-1 rounded-full">
                    {item.tag}
                  </span>
                )}
              </div>

              {/* Info */}
              <div className="p-5">
                <div className="text-[#e8734a] text-xs font-medium mb-1">{item.category}</div>
                <h3 className="text-[#1a3a4a] font-bold text-base mb-1.5">{item.name}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{item.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-[#e8734a]/70 text-xs font-medium tracking-wide italic">Fiyat için arayın</span>
                  <button className="flex items-center gap-1.5 text-[#e8734a] text-sm font-medium hover:gap-2.5 transition-all duration-200 cursor-pointer whitespace-nowrap">
                    Detay
                    <i className="ri-arrow-right-line text-sm"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Note */}
        <div className="text-center mt-10">
          <p className="text-gray-400 text-sm">
            <i className="ri-information-line mr-1"></i>
            Fiyatlar günlük piyasa koşullarına göre değişebilir. Güncel menü için bizi arayın.
          </p>
        </div>
      </div>
    </section>
  );
}
